import GoogleAnalyticsService from '../../../common/services/analytics/google-analytics.service';
import { Country } from '../../../common/models/country.model';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { LanguageChangeAction } from '../../../common/actions/language.action';
import UserService from '../../../common/services/user/user.service';
import TokenRedirectService from '../../../common/services/token-redirect.service';
import HttpService from '../../../common/services/http.service';

/* @ngInject */
export default class FooterController {
  public countries: Country[] = [];
  public availableLanguages = [];
  public country: Country;
  public language: string;

  constructor(
    private $window,
    private config,
    private i18n,
    private userService: UserService,
    private httpService: HttpService,
    private actionDispatcher: ActionDispatcherService,
    private tokenRedirectService: TokenRedirectService,
    private googleAnalytics: GoogleAnalyticsService
  ) {}

  public $onInit() {
    this.countries = this.config.countries;
    this.country = this.countries[0];
    this.availableLanguages = this.i18n.getAvailableLanguages();
    this.language = this.i18n.getCurrentLanguage();
  }

  public openAppStore() {
    this.$window.open(
      this.config.appstore[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openGooglePlay() {
    this.$window.open(
      this.config.playstore[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openWebPlayer() {
    this.tokenRedirectService.openPlayer();
  }

  public onLanguageChange = (lang: string) => {
    this.language = lang;
    this.i18n.useLanguage(this.language);
    this.actionDispatcher.dispatch(new LanguageChangeAction(this.language, true));
    this.googleAnalytics.writeVirtualPages({
      language: this.language
    });
    this.httpService.evictResultCache('getContract', true);
  };
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/footer/footer.controller.ts